<template>
  <div class="route-alive">
    <transition name="animation-fade-transform" mode="out-in">
      <keep-alive>
        <router-view v-if="!isIsolate && !isTransient && !onRefresh && !onUpgrade"
                     :key="currentNameId"
                     ref="instance"
                     v-on="hooks"></router-view>
      </keep-alive>
    </transition>
    <transition name="animation-fade-transform" mode="out-in">
      <router-view v-if="!isIsolate && isTransient && !onUpgrade"
                   :key="currentNameId"
                   :refresh="onRefresh"></router-view>
    </transition>
    <template v-if="include">
      <RouteIsolate v-for="key in include"
                    :key="key"
                    :is-current="isIsolate && key === current"
                    :is-refresh="onRefresh"></RouteIsolate>
    </template>
  </div>
</template>

<script>
import RouteIsolate from './RouteIsolate'
import routeUtils from '../../../util/routeUtils'
export default {
  name: 'RouteAlive',
  components: {
    RouteIsolate
  },
  props: {
    include: {
      type: Array
    },
    current: {
      type: [String, Number]
    }
  },
  data () {
    this.cache = {}
    return {
      onRefresh: false,
      onUpgrade: false
    }
  },
  computed: {
    hooks () {
      return {
        'hook:mounted': this.hookMounted,
        'hook:activated': this.hookActivated,
        'hook:destroyed': this.hookDestroyed
      }
    },
    currentRouteMatch () {
      return routeUtils.getRouteMatchId(this, this.$route)
    },
    currentNameId () {
      return this.currentRouteMatch.join(':')
    },
    isTransient () {
      return this.$route.meta.transient
    },
    isIsolate () {
      return this.$route.meta.isolate
    }
  },
  methods: {
    hookMounted () {
      this.cache[this.currentNameId] = this.$refs.instance
    },
    hookActivated () {
      this.cache[this.currentNameId] = this.$refs.instance
    },
    hookDestroyed () {
      Object.entries(this.cache).forEach(([key, item]) => {
        if (item && item._isDestroyed) {
          this.$emit('destroyed', key)
        }
      })
    },
    keepAliveInstance () {
      return this._vnode.children[0].child._vnode.componentInstance
    },
    removeCache (removeKeys) {
      if (removeKeys && removeKeys.length) {
        // 本地缓存清除
        Object.keys(this.cache).forEach(cacheKey => {
          if (this.checkCacheKeys(cacheKey, removeKeys)) {
            let item = this.cache[cacheKey]
            if (item) {
              delete this.cache[cacheKey]
              item.$destroy()
            }
          }
        })
        // keep-alive缓存清除
        let keepAlive = this.keepAliveInstance()
        if (keepAlive) {
          let {cache, keys} = keepAlive
          Object.entries(cache).find(([id, item]) => {
            let instance = item.componentInstance
            if (instance && instance.$vnode && instance.$vnode.data) {
              let key = instance.$vnode.data.key
              if (key && this.checkCacheKeys(key, removeKeys)) {
                delete cache[id]
                // 销毁组件实例
                instance.$destroy()
                let index = keys.indexOf(id)
                if (index >= 0) {
                  keys.splice(index, 1)
                }
              }
            }
          })
        }
        this.$emit('removed', removeKeys)
      }
    },
    refreshCurrent () {
      this.onRefresh = true
      const currentMatch = this.currentRouteMatch
      if (currentMatch.length) {
        let removeKeys
        if (this.isTransient) {
          removeKeys = [currentMatch[0]]
        } else {
          removeKeys = currentMatch
        }
        this.removeCache([removeKeys.join(':')])
      }
      this.$nextTick(() => {
        this.onRefresh = false
      })
    },
    checkCacheKeys (cacheKey, removeKeys) {
      if (removeKeys) {
        return removeKeys.some(removeKey => cacheKey === removeKey || cacheKey.startsWith(`${removeKey}:`))
      }
    }
  },
  watch: {
    include: {
      handler: function (val) {
        if (val) {
          this.removeCache(Object.keys(this.cache).filter(cacheKey => !this.checkCacheKeys(cacheKey, val)))
        }
      },
      deep: true
    },
    current: function () {
      // 解决嵌套路由页面没有及时更新
      this.onUpgrade = true
      this.$nextTick(() => {
        this.onUpgrade = false
      })
    }
  }
}
</script>

<style lang="scss">
  .route-alive {
    position: relative;
    height: 100%;
  }
</style>
